module.exports = __webpack_public_path__ + "static/media/6.6fd20b81.png";